"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var control_group_serialiser_1 = require("./../../control/control-group-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link MessageReceiverControlRegistrationParams}
 */
var MessageReceiverControlRegistrationParamsSerialiserClass = /** @class */ (function (_super) {
    __extends(MessageReceiverControlRegistrationParamsSerialiserClass, _super);
    function MessageReceiverControlRegistrationParamsSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link MessageReceiverControlRegistrationParams} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MessageReceiverControlRegistrationParams} to be written
     */
    MessageReceiverControlRegistrationParamsSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeInt32(bos, value.definition.id);
        control_group_serialiser_1.ControlGroupSerialiser.write(bos, value.group);
        Codec.writeString(bos, value.path);
        Codec.writeCollection(bos, value.keys, Codec.writeString);
    };
    return MessageReceiverControlRegistrationParamsSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessageReceiverControlRegistrationParamsSerialiserClass = MessageReceiverControlRegistrationParamsSerialiserClass;
/**
 * The {@link MessageReceiverControlRegistrationParamsSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessageReceiverControlRegistrationParamsSerialiser = new MessageReceiverControlRegistrationParamsSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/message-receiver-control-registration-params-serialiser.js
// module id = 575
// module chunks = 1